import PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import Icon from '../../Icons'

const MailingListsSection = ({
  isEditing,
  isSubmitting,
  isDisabled,
  subscribedClientMailingList,
  newSubClientMailingList,
  availableBuildingMailingList,
  setNewSubClientMailingList,
  setVisibleMailingListPopup,
  setIsEditingMailingListMode,
  setNewSubMailingList,
}) => {
  const { t } = useTranslation(['clients-legacy', 'common'])
  const removeOptionFromMailingList = (positionToRemove) => {
    setIsEditingMailingListMode(true)
    setNewSubClientMailingList(
      newSubClientMailingList.filter((position) => position.id !== positionToRemove.id),
    )
  }

  return (
    <div className="mailing-list">
      {isEditing ? (
        <div className="edit-bar">
          <div>{t('clients-legacy:profileView.mailingLists.editData')}</div>
          <div className="buttons">
            <button
              type="submit"
              className={`button button-gray is-block ${isSubmitting ? 'is-loading' : ''}`}
              onClick={() => {
                setNewSubClientMailingList(subscribedClientMailingList)
                setIsEditingMailingListMode(false)
              }}
              disabled={isSubmitting || isDisabled}
            >
              {t('common:actions.cancel')}
            </button>
            <button
              type="submit"
              className={`button button-primary is-block ${isSubmitting ? 'is-loading' : ''}`}
              onClick={setNewSubMailingList}
              disabled={isSubmitting || isDisabled}
            >
              {t('common:actions.save')}
            </button>
          </div>
        </div>
      ) : null}
      <div className="title">{t('clients-legacy:profileView.mailingLists.listsTitle')}</div>
      <div className="mailing-list-inner">
        {newSubClientMailingList.length &&
          newSubClientMailingList.map((item) => {
            return (
              <div key={item.id} className="subscribed-item">
                {item.value}
                {!isDisabled && item.value !== 'Emergency' && (
                  <span className="cross-icon" onClick={() => removeOptionFromMailingList(item)}>
                    <Icon icon="cross" viewBox="0 0 20 20" />
                  </span>
                )}
              </div>
            )
          })}
        {!isDisabled && newSubClientMailingList.length !== availableBuildingMailingList.length && (
          <div className="subscribed-item add-new" onClick={() => setVisibleMailingListPopup(true)}>
            <span className="plus-icon">
              <Icon icon="plus" viewBox="0 -6 20 20" />
            </span>
            {t('clients-legacy:profileView.mailingLists.addLabel')}
          </div>
        )}
      </div>
    </div>
  )
}

MailingListsSection.propTypes = {
  isEditing: PropTypes.bool,
  isSubmitting: PropTypes.bool,
  isDisabled: PropTypes.bool,
  subscribedClientMailingList: PropTypes.array,
  newSubClientMailingList: PropTypes.array,
  availableBuildingMailingList: PropTypes.array,
  setNewSubClientMailingList: PropTypes.func,
  setVisibleMailingListPopup: PropTypes.func,
  setIsEditingMailingListMode: PropTypes.func,
  setNewSubMailingList: PropTypes.func,
}

export default MailingListsSection
